import { Provider } from '@angular/core'
import { SettlingService } from 'game-services'
import { GamePlayConfig } from 'shared-services'
import { gamePlayConfigToken } from 'shared-components'

export const settlingServiceProvider: Provider = {
  provide: SettlingService,
  useFactory: (gamePlayConfig: GamePlayConfig): SettlingService => {
    return new SettlingService(gamePlayConfig)
  },
  deps: [gamePlayConfigToken],
}
